export const findId = (url = '') => url.substring(url.lastIndexOf(':') + 1)
